(function () {
	document.addEventListener("shopify:section:load", function () {
		const listEl = document.querySelector(".js-media-list");
		const subEl = document.querySelector(".js-media-sublist");
		if (!listEl || !subEl || typeof Swiper === "undefined") return;
		// If global init already ran, don't double-init and trigger reflows.
		if (listEl.swiper || subEl.swiper) return;

		const slider = new Swiper(listEl, getSliderSettings);
		const subSlider = new Swiper(subEl, getSubSliderProductSettings);

		setTimeout(function () {
			slider.update();
			subSlider.update();
		}, 200);
	});
})();

let attached = false;

let imageContainer = document.querySelector("#image");

const followMouse = (event) => {
	imageContainer.style.left = event.pageX + "px";
	imageContainer.style.top = event.pageY + "px";
};

function showImage() {
	if (!attached) {
		attached = true;
		imageContainer.style.display = "block";
		document.addEventListener("pointermove", followMouse);
	}
}

function hideImage() {
	attached = false;
	imageContainer.style.display = "";
	document.removeEventListener("pointermove", followMouse);
}
